import '../../assets/css/colors.css'
import '../../assets/css/Principais.css'
import '../../assets/css/fonts.css'
import '../../assets/css/estiloPaginas/homePage.css'
import TopMenu from '../TopMenu'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Rodape from '../Rodape'

var windowHeight = window.screen.availHeight;
export default function HomePage({ativaResp,showStyle}){

    const [logoAnimation, setLogoAnimation] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        setLogoAnimation(true)
      }, []);

      useEffect(() => {
        if (showStyle) {
          // Importa dinamicamente quando necessário
        //   import('../../assets/css/estilo.css');
        }
      }, [showStyle]);

    return <>
    <TopMenu ativaResp={ativaResp} showStyle={true}/>
    
        <div className="containerPrincipal homePage" style={{minHeight: "82vh", maxHeight: windowHeight*0.80, display: 'flex',
    flexDirection: 'column', overflowY: "hidden"}}>

            <div className={`homelogo ${logoAnimation ? 'logoAnima' : ''}`}></div>
            

        </div>
        <Rodape />
    </>
}